import { FC, useState } from "react";
import * as React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";

import { SwipeButton } from "./components/SwipeButton";

import Loader from "components/Loader";
import Button from "components/CustomButton";
interface SectionVideoProps {
  title: string;
  buttonType: "button" | "swipe";
  buttonText: string;
  video: string;
}

const SectionVideoModal: FC<SectionVideoProps> = ({
  title,
  buttonText,
  video,
  buttonType,
}) => {
  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      sx={{
        zIndex: 100000,
        height: "100lvh",
      }}
    >
      <Box
        sx={{
          position: "relative",
          height: "100%",
          width: "100%",
          overflowY: "hidden",
        }}
      >
        {loading ? <Loader /> : null}
        <Box
          component="video"
          autoPlay
          playsInline
          muted
          loop
          sx={{ height: "100%", width: "100%", objectFit: "cover" }}
          onLoadedData={() => setLoading(false)}
        >
          <Box component="source" src={video} type="video/mp4" />
        </Box>
        {/* Dark overlay */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.1)", // Semi-transparent black
          }}
        />
        <Typography
          sx={{
            fontSize: 48,
            position: "absolute",
            top: "45vh",
            width: "100%",
            textAlign: "center",
            color: "white",
            zIndex: 1,
            fontWeight: 600,
          }}
        >
          {title}
        </Typography>

        {buttonType === "swipe" ? (
          <SwipeButton onUnlock={handleClose} text={buttonText} />
        ) : (
          <Button
            sx={{
              position: "absolute",
              width: "75% !important",
              left: "12.5%",
              top: "70vh",
            }}
            className="button-outlined"
            onClick={handleClose}
          >
            {buttonText}
          </Button>
        )}
      </Box>
    </Dialog>
  );
};

export default SectionVideoModal;
